import type { TMessages } from '@/types/TMessages'

export const messages = {
  leasingMessage: 'Для покупки техники изучите предложения лизинга',
} satisfies TMessages
